import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IGioCongDongHoatDongActionTypes } from "../../action-types/gio-cong-dong/IGioCongDongHoatDongActionTypes";
import { eGioCongDongHoatDongReducerStatus, IGioCongDongHoatDongReducer } from "../../page-state-model/gio-cong-dong/IGioCongDongHoatDongReducer";
const iniState: IGioCongDongHoatDongReducer = {
    status: ePageBaseStatus.is_not_initialization,
    gioCongDongHoatDongs: []
}
export const gioCongDongHoatDongReducer = (state: IGioCongDongHoatDongReducer = iniState, action: IGioCongDongHoatDongActionTypes): IGioCongDongHoatDongReducer => {
    switch (action.type) {
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                gioCongDongHoatDongs: action.payload
            }
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                gioCongDongHoatDongs: []
            }
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_DETAIL_START":
            return {
                ...state,
                status: eGioCongDongHoatDongReducerStatus.is_loading_detail
            }
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_DETAIL_SUCCESS":
            return {
                ...state,
                status: eGioCongDongHoatDongReducerStatus.is_load_detail_success,
                editingData: action.payload,
                savedId: undefined
            }
        case "GIO_CONG_DONG_HOAT_DONG_LOAD_DETAIL_ERROR":
            return {
                ...state,
                status: eGioCongDongHoatDongReducerStatus.is_load_detail_error,
                editingData: undefined
            }

        case "GIO_CONG_DONG_HOAT_DONG_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "GIO_CONG_DONG_HOAT_DONG_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                savedId: action.payload
            }
        case "GIO_CONG_DONG_HOAT_DONG_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "GIO_CONG_DONG_HOAT_DONG_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "GIO_CONG_DONG_HOAT_DONG_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "GIO_CONG_DONG_HOAT_DONG_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }

        default:
            return state;
    }
}